/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { KTIcon } from '../../../helpers'
import { Link } from 'react-router-dom'

type Props = {
  className: string
  color: string
  svgIcon: string
  iconColor: string
  title: string
  titleColor?: string
  description: string
  descriptionColor?: string
  isClickable?: boolean
  linkTo?: string
  exclude?: string
}

const StatisticsWidget5: React.FC<Props> = ({
  className,
  color,
  svgIcon,
  iconColor,
  title,
  titleColor,
  description,
  descriptionColor,
  isClickable = false,
  linkTo = '',
  exclude = ''
}) => {
  const content = (
    <div className={`card bg-${color} hoverable ${className}`}>
      <div className='card-body'>
        <KTIcon iconName={svgIcon} className={`text-${iconColor} fs-2x  me-3`} />
        <span className={`text-${titleColor} fw-bold fs-1 `}>{title}</span>
        <div className={`fw-semibold fs-3 text-${descriptionColor}`}>{description} <span className='fs-8'>{exclude}</span>        </div>
      </div>
    </div>
  );

  return isClickable ? (
    <Link to={linkTo} className="text-decoration-none">
      {content}
    </Link>
  ) : (
    content
  );
}


export { StatisticsWidget5 }
